import { Accordion } from '../../../../../../components/general/accordion';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { Grid } from '@mui/material';
import FieldText from '../../../../../../components/general/fields/fieldText';
import { PqrClosingProps } from '../props';
import { usePqrNonComplianceReason } from './hook';

export const PqrNonComplianceReason = ({ closing }: PqrClosingProps) => {
    const { formik } = usePqrNonComplianceReason(closing);

    return (
        <Accordion
            title="MOTIVO DE INCUMPLIMIENTO"
            icon={
                <SentimentVeryDissatisfiedIcon sx={{ color: 'primary.main' }} />
            }
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} md={6}>
                    <FieldText
                        label="Motivo incumplimiento"
                        name="nonComplianceReason"
                        size="small"
                        value={formik.values.nonComplianceReason}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
